import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IPaymentMethod } from "@app/common";

interface PaymentMethodDeleteModalProps extends ModalInstance<IPaymentMethod>, Omit<DeleteModalProps<IPaymentMethod>, 'children'> {
  onDelete: (product: Partial<IPaymentMethod>) => void;
}

export const PaymentMethodDeleteModal = (props: PaymentMethodDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer un moyen de paiement.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}